import { SetterOrUpdater, useRecoilState, useSetRecoilState } from 'recoil';
import { ModalState } from '../../models/ModalState';
import { modalState } from '../../recoil/selectors';
import { ModalToggleState } from '../../models/actionStates';

export const useSetModalState = (): SetterOrUpdater<ModalState> => {
  return useSetRecoilState(modalState);
};

export const useAdvanceModalState = (): ((state: ModalState) => void) => {
  const [previousState, set] = useRecoilState(modalState);
  const cleanPreviousState = previousState.toggleState === ModalToggleState.Closed ? undefined : previousState;
  return (state: ModalState) => {
    set({ ...state, previousState: cleanPreviousState });
  };
};

export const useReverseModalState = (fromPopState = false): (() => void) => {
  const [state, set] = useRecoilState(modalState);
  const { previousState } = state;

  return () => {
    previousState
      ? set({ ...previousState, isReverse: true, fromPopState })
      : set({
          toggleState: ModalToggleState.Closed,
        });
  };
};

export const useGoToBaseModalState = (): (() => void) => {
  const [previousState, set] = useRecoilState(modalState);
  return () => {
    const recursivelyFindBaseState = (state: ModalState | undefined): ModalState | undefined =>
      state?.isBaseState ? state : state ? recursivelyFindBaseState(state?.previousState) : undefined;
    const baseState = recursivelyFindBaseState(previousState);
    baseState
      ? set(baseState)
      : set({
          toggleState: ModalToggleState.Closed,
        });
  };
};
